import { createReducer } from 'redux-starter-kit';

import {
  changePaymentMethod,
  toggleSavedPaymentInfo,
  tokenizeStripe,
  tokenizeStripeSuccess,
  tokenizeStripeFailure,
  tokenizePaypal,
  tokenizePaypalSuccess,
  tokenizePaypalFailure,
  orderBundle,
  orderBundleSuccess,
  orderBundleFailure,
  orderTemplate,
  orderTemplateSuccess,
  orderTemplateFailure,
  orderComplete,
  reset,
  stripeRequireAction,
  stripeConfirmPaymentSuccess,
  stripeConfirmPaymentFailure,
  stripeConfirmPayment,
  checkCaptcha,
  checkCaptchaComplete
} from 'actions/order';
import { fetchPaymentInfoSuccess, fetchPaymentInfoFailure } from 'actions/user';
import { logout } from 'actions/auth';

export default createReducer(
  {
    useSavedPaymentInfo: false,
    useCreditCard: true,
    usePaypal: false,
    isProcessing: false,
    purchaseSuccessful: false,
    captchaSuccessful: false
  },
  {
    // payment options
    [toggleSavedPaymentInfo]: state => ({
      ...state,
      useSavedPaymentInfo: !state.useSavedPaymentInfo
    }),
    [changePaymentMethod]: (state, action) => ({
      ...state,
      useCreditCard: action.payload === 'credit_card',
      usePaypal: action.payload === 'paypal'
    }),
    [fetchPaymentInfoSuccess]: state => ({
      ...state,
      useSavedPaymentInfo: true
    }),
    [fetchPaymentInfoFailure]: state => ({
      ...state,
      useSavedPaymentInfo: false
    }),

    // tokenize Stripe
    [tokenizeStripe]: state => ({
      ...state,
      isProcessing: true
    }),
    [tokenizeStripeSuccess]: state => ({
      ...state,
      isProcessing: false
    }),
    [tokenizeStripeFailure]: state => ({
      ...state,
      isProcessing: false
    }),
    [stripeRequireAction]: (state, action) => ({
      ...state,
      pendingStripeAction: action.payload
    }),
    [stripeConfirmPayment]: state => ({
      ...state,
      pendingStripeAction: null,
      isProcessing: true
    }),
    [stripeConfirmPaymentSuccess]: state => ({
      ...state,
      isProcessing: false
    }),
    [stripeConfirmPaymentFailure]: state => ({
      ...state,
      isProcessing: false
    }),

    // tokenize Paypal
    [tokenizePaypal]: state => ({
      ...state,
      isProcessing: true
    }),
    [tokenizePaypalSuccess]: state => ({
      ...state,
      isProcessing: false
    }),
    [tokenizePaypalFailure]: state => ({
      ...state,
      isProcessing: false
    }),

    // ORDER Image & Audio Bundle
    [orderBundle]: (state, action) => ({
      ...state,
      isProcessing: true,
      productId: action.payload ? action.payload.productId : undefined
    }),
    [orderBundleSuccess]: state => ({
      ...state,
      isProcessing: false,
      purchaseSuccessful: true,
      purchasedProductId: state.productId,
      productId: undefined
    }),
    [orderBundleFailure]: state => ({
      ...state,
      isProcessing: false
    }),
    [orderComplete]: state => ({
      ...state,
      purchasedProductId: undefined
    }),

    // ORDER Video Template
    [orderTemplate]: state => ({
      ...state,
      isProcessing: true
    }),
    [orderTemplateSuccess]: state => ({
      ...state,
      isProcessing: false,
      purchaseSuccessful: true
    }),
    [orderTemplateFailure]: state => ({
      ...state,
      isProcessing: false
    }),

    // clear redirection
    [reset]: state => ({
      ...state,
      isProcessing: false,
      purchaseSuccessful: false
    }),

    // clear saved payment info on logout
    [logout]: (state, active) => ({
      ...state,
      useSavedPaymentInfo: false
    }),

    // handle captcha tokens
    [checkCaptcha]: state => ({
      ...state,
      isProcessing: true
    }),
    [checkCaptchaComplete]: (state, action) => {
      return {
        ...state,
        isProcessing: false,
        captchaSuccessful: action.payload.success
      };
    }
  }
);
